module.exports = __webpack_public_path__ + "img/logo.b65a8f78.png";